export class Breadcrumbs{
    BreadcrumbName: string;
    BreadcrumbLink: string;
    Level: number;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/cms/breadcrumbs.ts